export const BASE_URL = 'https://api.multi-services.se:8000/rest';
//export const BASE_URL = 'http://localhost:8083/rest';

export const urls = {
  dashboard: {
    statistics: `${BASE_URL}/dashboard`,
    ordersChart: `${BASE_URL}/dashboard/orders/chart`,
    latestOrders: `${BASE_URL}/dashboard/orders/latest`,
  },
  languages: {
    all: `${BASE_URL}/language/`,
  },
  taxTypes: {
    all: `${BASE_URL}/taxtype/`,
  },

  categories: {
    all: `${BASE_URL}/category/`,
    details: `${BASE_URL}/category`,
  },
  product: {
    details: `${BASE_URL}/product`,
  },
  orders: {
    updateStatus: `${BASE_URL}/order/status/pay`,
  },
  setting: {
    get: `${BASE_URL}/setting`,
  },
};
